"use client"

import { cn } from "@/lib/utils"
import { SearchX } from "lucide-react"

interface EmptyStateProps {
  message?: string
  className?: string
}

export function EmptyState({
  message = "No posts found matching your search.",
  className
}: EmptyStateProps) {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-12 sm:py-16 px-4",
      className
    )}>
      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-bg-alt border border-border flex items-center justify-center mb-4 sm:mb-6">
        <SearchX className="w-7 h-7 sm:w-8 sm:h-8 text-text-muted" />
      </div>
      <p className="text-base sm:text-lg text-text-muted text-center max-w-md">
        {message}
      </p>
    </div>
  )
}
